// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { 
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc, } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { 
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut, deleteUser } from "firebase/auth"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
/* const firebaseConfig = {
    apiKey: "AIzaSyBIVvQBwv2BpiXJlHJgaaEyh3Sc0sEod1I",
    authDomain: "weee-81f51.firebaseapp.com",
    projectId: "weee-81f51",
    storageBucket: "weee-81f51.appspot.com",
    messagingSenderId: "618604651963",
    appId: "1:618604651963:web:5c1261debdf7f38b63909e",
    measurementId: "G-M3S903MQNE"
}; */

const firebaseConfig = {
  apiKey: "AIzaSyBIiHjto6ox7lB9TpeW_QUSq3JfnjhPVE0",
  authDomain: "app3r-56fb5.firebaseapp.com",
  projectId: "app3r-56fb5",
  storageBucket: "app3r-56fb5.appspot.com",
  messagingSenderId: "614133577445",
  appId: "1:614133577445:web:ff731e2783e53d9804060c",
  measurementId: "G-EMT1TGHKJY"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
    try {
        const res = await signInWithPopup(auth, googleProvider);
        const user = res.user;
        const q = query(collection(db, "users"), where("uid", "==", user.uid));
        const docs = await getDocs(q);
        if (docs.docs.length === 0) {
            await addDoc(collection(db, "users"), {
                uid: user.uid,
                name: user.displayName,
                authProvider: "google",
                email: user.email,
            });
        }
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};
  
const logInWithEmailAndPassword = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};
  
const registerWithEmailAndPassword = async (name, email, password) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const user = res.user;
        await addDoc(collection(db, "users"), {
            uid: user.uid,
            name,
            authProvider: "local",
            email,
        });
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};
  
const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        alert("Password reset link sent!");
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};
  
const logout = () => {
    signOut(auth);
};

export { 
    db, storage, analytics, 
    auth, 
    signInWithGoogle,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    logout, deleteUser,
    signInWithEmailAndPassword,
};